const countryOptions: { [key: string]: string } = {
  CA: 'Canada',
  US: 'United States',
  // AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AI: 'Anguilla',
  AG: 'Antigua Barbuda',
  AR: 'Argentina',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AP: 'Azores',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BE: 'Belgium',
  BZ: 'Belize',
  BY: 'Belarus',
  BJ: 'Benin',
  BM: 'Bermuda',
  BO: 'Bolivia',
  BL: 'Bonaire',
  BA: 'Bosnia',
  BW: 'Botswana',
  BR: 'Brazil',
  VG: 'British Virgin Islands',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  IC: 'Canary Islands',
  CV: 'Cape Verde Islands',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CD: 'Channel Islands',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  CG: 'Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CB: 'Curacao',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  EN: 'England',
  GQ: 'Equitorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FO: 'Faeroe Islands',
  FM: 'Federated States of Micronesia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HO: 'Holland',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  // IR: 'Iran',
  IR: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  CI: 'Ivory Coast',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KO: 'Kosrae',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macau',
  MK: 'Macedonia',
  MG: 'Madagascar',
  ME: 'Madeira',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  MD: 'Moldova',
  MC: 'Monaco',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NP: 'Nepal',
  NL: 'Netherlands',
  AN: 'Netherlands Antilles',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NF: 'Norfolk Island',
  NB: 'Northern Ireland',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PO: 'Ponape',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  IE: 'Ireland',
  YE: 'Republic of Yemen',
  RE: 'Reunion',
  RO: 'Romania',
  RT: 'Rota',
  RU: 'Russia',
  RW: 'Rwanda',
  SS: 'Saba',
  SP: 'Saipan',
  SA: 'Saudi Arabia',
  SF: 'Scotland',
  SN: 'Senegal',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  ZA: 'South Africa',
  KR: 'South Korea',
  ES: 'Spain',
  LK: 'Sri Lanka',
  NT: 'St. Barthelemy',
  SW: 'St. Christopher',
  SX: 'St. Croix',
  EU: 'St. Eustatius',
  UV: 'St. John',
  KN: 'St. Kitts Nevis',
  LC: 'St. Lucia',
  MB: 'St. Maarten',
  TB: 'St. Martin',
  VL: 'St. Thomas',
  VC: 'St. Vincent the Grenadines',
  SD: 'Sudan',
  SR: 'Suriname',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TA: 'Tahiti',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TI: 'Tinian',
  TG: 'Togo',
  TO: 'Tonga',
  TL: 'Tortola',
  TT: 'Trinidad Tobago',
  TU: 'Truk',
  TN: 'Tunisia',
  TR: 'Turkey',
  TC: 'Turks Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  UI: 'Union Island',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UY: 'Uruguay',
  VI: 'US Virgin Islands',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VR: 'Virgin Gorda',
  WK: 'Wake Island',
  WL: 'Wales',
  WF: 'Wallis Futuna Islands',
  WS: 'Western Samoa',
  YA: 'Yap',
  YU: 'Yugoslavia',
  ZR: 'Zaire',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

export default countryOptions;
